// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3OZ9C","productName":"Table_productName__3hPai"};